<template>
    <div class="trailerWatch">
        <video
            ref="videoRef"
            autoplay
            :muted="trailerSound"
            tabindex="-1"
            playsinline
            src=""
            @play="onVideoLoaded"
            @ended="onVideoEnded"
            v-if="!hidePlayer"
            draggable="false"
        ></video>
        <div class="poster" :class="{ hide: loaded }">
            <img :src="poster" loading="lazy" alt="poster" draggable="false" />
        </div>
    </div>
</template>



<script>
// import Hls from "@tianfeng98/hls.js";
import Hls from "hls.js";
import { getMovieUrl } from "../../Api/index";
class CustomLoader extends Hls.DefaultConfig.loader {
    constructor(config) {
        super(config);
    }

    load(context, config, callbacks) {
        


        const onSuccess = callbacks.onSuccess;
        
        callbacks.onSuccess = (response, stats, context) => {
            if (
                context.url.includes("cas.tvcom.uz") &&
                response.data instanceof ArrayBuffer
            ) {
                response.data = this.invertArrayBuffer(response.data);
            }
            onSuccess(response, stats, context);
        };

        super.load(context, config, callbacks);
    }

    invertArrayBuffer(buffer) {
        const uint8View = new Uint8Array(buffer);
        for (let i = 0; i < uint8View.length; i++) {
            uint8View[i] = ~uint8View[i];
        }
        return buffer;
    }
}
export default {
    props: ["link", "poster", "trailerSound", "destoryPlayer"],
    emits: ["trailerIsEnded", "trailerStarted"],
    data: () => ({
        hlsInstance: null,
        hidePlayer: false,

        hlsSource: "",
        loaded: false,
        config: {
            // lowLatencyMode: false,
            enableWorker: true,
            // lazyLoad: true,
            // startFragPrefetch: true,
            // startLevel: 0,
            // capLevelToPlayerSize: false, // false
            // capLevelOnFPSDrop: false, // false
            // ignoreDevicePixelRatio: false, // false
            // debug: false, // false
            // autoStartLoad: true, // true
            // startPosition: -1, // -1
            // initialLiveManifestSize: 1, // 1
            // maxBufferLength: 30, // 30
            // backBufferLength: 0, // Infinity
            // frontBufferFlushThreshold: Infinity, // Infinity
            // maxBufferSize: 40_000_000, // 60_000_000
            // maxBufferHole: 0.5, // 0.5
            // maxStarvationDelay: 4, // 4
            // maxLoadingDelay: 4, // 4
            // highBufferWatchdogPeriod: 3, // 3
            // nudgeOffset: 0.1, // 0.1
            // nudgeMaxRetry: 3, // 3
            // maxFragLookUpTolerance: 0.25, // 0.25
            // maxMaxBufferLength: 600, // 600
            // liveSyncDurationCount: 100, // 3
            // liveMaxLatencyDurationCount: Infinity, // Infinity,

            loader: CustomLoader,
        },
    }),
    beforeUnmount() {
        if (this.hlsInstance) {
            this.hlsInstance.detachMedia();
            this.hlsInstance.destroy();
            this.hlsInstance = null;
        }
    },
    mounted() {
        this.watchTrailer();
    },
    watch: {
        hlsSource(value) {
            if (this.hlsInstance) {
                this.hlsInstance.detachMedia();
                this.hlsInstance.destroy();
                this.hlsInstance = null;
            }
            this.createHlsInstance(value);
            if (Hls.isSupported()) {
                if (this.hlsInstance) {
                    this.hlsInstance.detachMedia();
                    this.hlsInstance.destroy();
                    this.hlsInstance = null;
                }
                this.createHlsInstance(value);
            } else {
                this.$refs.videoRef.src = this.hlsSource;
            }
        },
        destoryPlayer(value) {
            if (value) {
                this.descroyHlsInstance();
            }
        },
    },
    methods: {
        createHlsInstance(hlsSource) {
            const hls = new Hls(this.config);
            this.hlsInstance = hls;
            const videoRef = this.$refs.videoRef;
            hls.loadSource(hlsSource);
            hls.attachMedia(videoRef);
        },
        descroyHlsInstance() {
            if (this.hlsInstance) {
                this.loaded = false;
                this.hidePlayer = true;
                this.hlsInstance.detachMedia();
                this.hlsInstance.destroy();
                this.hlsInstance = null;
            }
        },
        onVideoLoaded() {
            this.loaded = true;
            this.$emit("trailerStarted");
        },
        onVideoEnded() {
            this.descroyHlsInstance();
            this.$emit("trailerIsEnded");
        },
        watchTrailer() {
            this.setPlayerConfig(this.link);
        },
        setPlayerConfig(videoAction) {
            let action;
            action = videoAction;
            this.fetchVideoSource(action.video_id, action.file_id);
        },

        async fetchVideoSource(videoId, videoFileId) {
            const data = await getMovieUrl(videoId, videoFileId);
            if (data.error) {
                this.hlsSource = "error";
                return;
            }
            let uri = data.uri.replace("http:", "https:").replace(":8180", "");
            uri = uri.includes("-4K.mp4")
                ? uri.replace("index.m3u8", "index.fmp4.m3u8")
                : uri;
            this.hlsSource = uri;

            return uri;
        },
    },
};
</script>

<style lang="scss" scoped>
.trailerWatch {
    width: 100%;
    height: 100%;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    video {
        width: 110%;
        height: 100%;
        object-fit: cover;
    }
    .poster {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        transition: all 0.5s ease;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: blur(29.049999237060547px);
        }
        opacity: 1;
        &.hide {
            opacity: 0;
        }
    }
}
</style>
